import React, { useState, useEffect } from 'react';
import { Tag, Plus, X } from 'lucide-react';

const API_URL = import.meta.env.VITE_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:3000/api' : '/api');

export default function AthleteTagsModal({ athlete, onClose, onSave }) {
  const [tags, setTags] = useState([]);
  const [newTag, setNewTag] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (athlete && athlete.tags) {
      setTags([...athlete.tags]);
    } else {
      setTags(['General']);
    }
  }, [athlete]);

  const handleAddTag = (e) => {
    e.preventDefault();
    if (!newTag.trim()) return;
    if (tags.includes(newTag.trim())) return;
    setTags([...tags, newTag.trim()]);
    setNewTag('');
  };

  const handleRemoveTag = (tagToRemove) => {
    setTags(tags.filter(t => t !== tagToRemove));
  };

  const handleSave = async () => {
    setIsSaving(true);
    setError(null);
    try {
      const res = await fetch(`${API_URL}/coach/clients/${athlete.id}/tags`, {
        method: 'PUT',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ tags })
      });
      
      if (!res.ok) {
        throw new Error('Error al guardar etiquetas');
      }
      
      onSave(tags);
    } catch (err) {
      setError(err.message);
      setIsSaving(false);
    }
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(5px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000, padding: '1rem'
    }}>
      <div className="glass-panel" style={{ width: '100%', maxWidth: '500px', padding: '0', overflow: 'hidden' }}>
        
        {/* Header */}
        <div style={{ padding: '1.5rem', borderBottom: '1px solid var(--glass-border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
            <div style={{ background: 'rgba(139, 92, 246, 0.2)', color: '#8b5cf6', padding: '0.6rem', borderRadius: '50%' }}>
              <Tag size={20} />
            </div>
            <h2 style={{ margin: 0, color: 'white', fontSize: '1.2rem' }}>Etiquetas de {athlete.name.split(' ')[0]}</h2>
          </div>
          <button onClick={onClose} style={{ background: 'transparent', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: '1.5rem' }}>×</button>
        </div>

        {/* Body */}
        <div style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          {error && <div style={{ color: '#ef4444', fontSize: '0.9rem', background: 'rgba(239, 68, 68, 0.1)', padding: '0.8rem', borderRadius: '8px' }}>{error}</div>}
          
          <form onSubmit={handleAddTag} style={{ display: 'flex', gap: '0.5rem' }}>
            <input 
              type="text" 
              value={newTag}
              onChange={(e) => setNewTag(e.target.value)}
              placeholder="Ej. Ciclista, Sub-23, Pro..."
              style={{ flex: 1, padding: '0.8rem', borderRadius: '8px', border: '1px solid var(--glass-border)', background: 'rgba(255,255,255,0.05)', color: 'white' }}
            />
            <button type="submit" disabled={!newTag.trim()} style={{ padding: '0 1rem', borderRadius: '8px', border: 'none', background: 'var(--health-green)', color: 'black', cursor: newTag.trim() ? 'pointer' : 'not-allowed', fontWeight: 'bold' }}>
              <Plus size={20} />
            </button>
          </form>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', minHeight: '80px', alignContent: 'flex-start' }}>
            {tags.length === 0 ? (
              <span style={{ color: 'var(--text-muted)', fontSize: '0.9rem', fontStyle: 'italic' }}>No hay etiquetas asignadas.</span>
            ) : (
              tags.map(tag => (
                <div key={tag} style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', background: 'rgba(139, 92, 246, 0.15)', border: '1px solid rgba(139, 92, 246, 0.3)', color: '#d8b4fe', padding: '0.4rem 0.8rem', borderRadius: '16px', fontSize: '0.9rem' }}>
                  <span>{tag}</span>
                  <X size={14} style={{ cursor: 'pointer', opacity: 0.7 }} onClick={() => handleRemoveTag(tag)} />
                </div>
              ))
            )}
          </div>
        </div>

        {/* Footer */}
        <div style={{ padding: '1.5rem', borderTop: '1px solid var(--glass-border)', display: 'flex', justifyContent: 'flex-end', gap: '1rem', background: 'rgba(0,0,0,0.2)' }}>
          <button onClick={onClose} style={{ padding: '0.6rem 1.2rem', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'transparent', color: 'white', cursor: 'pointer' }}>
            Cancelar
          </button>
          <button 
            onClick={handleSave} 
            disabled={isSaving}
            style={{ padding: '0.6rem 1.5rem', borderRadius: '8px', border: 'none', background: 'var(--health-cyan)', color: 'black', fontWeight: 'bold', cursor: isSaving ? 'not-allowed' : 'pointer' }}
          >
            {isSaving ? 'Guardando...' : 'Guardar'}
          </button>
        </div>
      </div>
    </div>
  );
}
